<template lang="pug">
  label.checkbox-input(
    @click="toggleCheckbox()"
  )
    span.checkbox-input__checkbox.checkbox--toggle-all(
      :class="`toggle-all--${this.checkedState}`"
    )
      icon(
        :name="iconName"
        size="12px"
      )
    .checkbox-input__label-text(v-if="label") {{ label }}
    .checkbox-input__label-text(v-else)
      slot
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'CheckboxToggleAll',
    components: {
      Icon,
    },
    props: {
      allOptions: Object,
      value: String,
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      name: String,
      id: String,
      checked: String,
      toggle: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        checkedState: this.checked,
      };
    },
    computed: {
      inputId() {
        return this.id || `checkbox_${this._uid}`;
      },
      inputClass() {
        return ''
      },
      iconName() {
        if (this.checkedState === 'checked' ) {
          return 'check'
        } else if (this.checkedState === 'intermediary') {
          return 'toggle-minus'
        } else {
          return ''
        }
      }
    },
    methods: {
      toggleCheckbox() {
        if (this.checkedState === 'checked' || this.checkedState === 'intermediary') {
          this.checkedState = 'unchecked';
        } else if (this.checkedState === 'unchecked') {
          this.checkedState = 'checked';
        }
      }
    },
    watch: {
      allOptions: {
        handler(options) {
          if (Object.values(options).every(Boolean)) {
            this.checkedState = 'checked'
          } else if (Object.values(options).every(option => option === false)) {
            this.checkedState = 'unchecked'
          } else {
            this.checkedState = 'intermediary'
          }
        }, deep: true
      },
      checkedState(newCheckedState) {
        if (newCheckedState === 'checked' || newCheckedState === 'unchecked') {
          this.$emit('input', newCheckedState);
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .icon--minus {
    stroke: var(--color-white) !important;
  }
</style>